<h2 mat-dialog-title>Settings</h2>
<mat-dialog-content>
  <mat-tab-group class="vertical" mat-align-tabs="start">
    <mat-tab label="Personalization">
      <div class="row ml-2">
        <div class="col-md-6">
          <mat-form-field class="full-width">
            <mat-label>Language</mat-label>
            <mat-select [(ngModel)]="localeValue">
              <mat-option [value]="locale" *ngFor="let locale of localeList">
                {{ locale?.displayName }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <app-myThemesDropdown
            class="w-100"
            [options]="appInitService._themeList"
            [theme]="appInitService.currentTheme"
            (themeChange)="themeChangeHandler($event)"
          >
          </app-myThemesDropdown>
        </div>
        <div class="col-md-6 images">
          <img src="./assets/images/font.svg" height="150px" width="200px" />
        </div>
        <div class="col-md-6 images">
          <img
            src="../../../../assets/images/theme.svg"
            height="150px"
            width="200px"
          />
        </div>
        <div class="col-md-6 images">
          <p>Select a language and click on save to apply.</p>
        </div>
        <div class="col-md-6 images">
          <p>Select a theme and click on save to apply.</p>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Date & Time Settings" [formGroup]="myform" *ngIf="false">
      <div class="">
        <mat-tab-group class="setting-page horizontal ml-3">
          <mat-tab label="Date Formats" class="vertical-formats">
            <div class="mr-4 ml-1 mt-2">
              <div class="row">
                <div class="col-md-6">
                  <mat-label class="ng-select-label"
                    >Default Date Format</mat-label
                  >
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="dateFormatList"
                    bindLabel="optionText"
                    formControlName="selectedDateFormat"
                    placeholder="Default Date Format"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <mat-label class="ng-select-label">Short Date</mat-label>
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="shortDateList"
                    bindLabel="optionText"
                    formControlName="selectedShortDate"
                    placeholder="Short Date"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
                <div class="col-md-6">
                  <mat-label class="ng-select-label">Long Date</mat-label>
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="longDateList"
                    bindLabel="optionText"
                    formControlName="selectedLongDate"
                    placeholder="Long Date"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
                <div class="col-md-6">
                  <mat-label class="ng-select-label">Medium Date</mat-label>
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="medDateList"
                    bindLabel="optionText"
                    formControlName="selectedMedDate"
                    placeholder="Medium Date"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
                <div class="col-md-6">
                  <mat-label class="ng-select-label">Full Date</mat-label>
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="fullDateList"
                    bindLabel="optionText"
                    formControlName="selectedFullDate"
                    placeholder="Full Date"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Time Formats">
            <div class="mr-4 ml-1 mt-2">
              <div class="row">
                <div class="col-md-6">
                  <mat-label class="ng-select-label"
                    >Default Time Format</mat-label
                  >
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="timeFormatList"
                    bindLabel="optionText"
                    formControlName="selectedTimeFormat"
                    placeholder="Default Time Format"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <mat-label class="ng-select-label">Short Time</mat-label>
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="shortTimeList"
                    bindLabel="optionText"
                    formControlName="selectedShortTime"
                    placeholder="Short Time"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
                <div class="col-md-6">
                  <mat-label class="ng-select-label">Long Time</mat-label>
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="longTimeList"
                    bindLabel="optionText"
                    formControlName="selectedLongTime"
                    placeholder="Long Time"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
                <div class="col-md-6">
                  <mat-label class="ng-select-label">Medium Time</mat-label>
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="medTimeList"
                    bindLabel="optionText"
                    formControlName="selectedMedTime"
                    placeholder="Medium Time"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
                <div class="col-md-6">
                  <mat-label class="ng-select-label">Full Time</mat-label>
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="fullTimeList"
                    bindLabel="optionText"
                    formControlName="selectedFullTime"
                    placeholder="Full Time"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Date-Time Formats">
            <div class="mr-4 ml-1 mt-2">
              <div class="row">
                <div class="col-md-6">
                  <mat-label class="ng-select-label"
                    >Default Date-Time Format</mat-label
                  >
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="dtFormatList"
                    bindLabel="optionText"
                    formControlName="selectedDtFormat"
                    placeholder="Default Date-Time Format"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <mat-label class="ng-select-label">Short Date-Time</mat-label>
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="shortDtList"
                    bindLabel="optionText"
                    formControlName="selectedShortDt"
                    placeholder="Short Date-Time"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
                <div class="col-md-6">
                  <mat-label class="ng-select-label">Long Date-Time</mat-label>
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="longDtList"
                    bindLabel="optionText"
                    formControlName="selectedLongDt"
                    placeholder="Long Date-Time"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
                <div class="col-md-6">
                  <mat-label class="ng-select-label"
                    >Medium Date-Time</mat-label
                  >
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="medDtList"
                    bindLabel="optionText"
                    formControlName="selectedMedDt"
                    placeholder="Medium Date-Time"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
                <div class="col-md-6">
                  <mat-label class="ng-select-label">Full Date-Time</mat-label>
                  <ng-select
                    appearance="fill"
                    #department
                    [items]="fullDtList"
                    bindLabel="optionText"
                    formControlName="selectedFullDt"
                    placeholder="Full Date-Time"
                    appendTo="body"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
      <!-- <div class="row ml-2" >
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="dateFormatList"
            bindLabel="optionText"
            formControlName="selectedDateFormat"
            (change)="onClickdateFormat()"
            placeholder="Date Format"
            appendTo="body"
          >
          </ng-select>
        </div>
      </div>
      <div class="row ml-2" >
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="shortDateList"
            bindLabel="optionText"
            formControlName="selectedShortDate"
            (change)="onClickShortDate()"
            placeholder="Short Date"
            appendTo="body"
          >
          </ng-select>
        </div>
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="longDateList"
            bindLabel="optionText"
            formControlName="selectedLongDate"
            (change)="onClickLongDate()"
            placeholder="Long Date"
            appendTo="body"
          >
          </ng-select>
        </div>
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="medDateList"
            bindLabel="optionText"
            formControlName="selectedMedDate"
            (change)="onClickMedDate()"
            placeholder="Medium Date"
            appendTo="body"
          >
          </ng-select>
        </div>
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="fullDateList"
            bindLabel="optionText"
            formControlName="selectedFullDate"
            (change)="onClickfullDate()"
            placeholder="Full Date"
            appendTo="body"
          >
          </ng-select>
        </div>
      </div>
      <mat-divider></mat-divider>
        <div class="row ml-2 mt-2" >
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="timeFormatList"
            bindLabel="optionText"
            formControlName="selectedTimeFormat"
            (change)="onClickTimeFormat()"
            placeholder="Time Format"
            appendTo="body"
          >
          </ng-select>
        </div>
      </div>
      <div class="row ml-2" >
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="shortTimeList"
            bindLabel="optionText"
            formControlName="selectedShortTime"
            (change)="onClickShortTime()"
            placeholder="Short Time"
            appendTo="body"
          >
          </ng-select>
        </div>
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="longTimeList"
            bindLabel="optionText"
            formControlName="selectedLongTime"
            (change)="onClickLongTime()"
            placeholder="Long Time"
            appendTo="body"
          >
          </ng-select>
        </div>
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="medTimeList"
            bindLabel="optionText"
            formControlName="selectedMedTime"
            (change)="onClickMedTime()"
            placeholder="Medium Time"
            appendTo="body"
          >
          </ng-select>
        </div>
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="fullTimeList"
            bindLabel="optionText"
            formControlName="selectedFullTime"
            (change)="onClickFullTime()"
            placeholder="Full Time"
            appendTo="body"
          >
          </ng-select>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="row ml-2 mt-2" >
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="dtFormatList"
            bindLabel="optionText"
            formControlName="selectedDtFormat"
            (change)="onClickDtFormat()"
            placeholder="Date-Time Format"
            appendTo="body"
          >
          </ng-select>
        </div>
      </div>
      <div class="row ml-2" >
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="shortDtList"
            bindLabel="optionText"
            formControlName="selectedShortDt"
            (change)="onClickShortDt()"
            placeholder="Short Date-Time"
            appendTo="body"
          >
          </ng-select>
        </div>
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="longDtList"
            bindLabel="optionText"
            formControlName="selectedLongDt"
            (change)="onClickLongDt()"
            placeholder="Long Date-Time"
            appendTo="body"
          >
          </ng-select>
        </div>
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="medDtList"
            bindLabel="optionText"
            formControlName="selectedMedDt"
            (change)="onClickMedDt()"
            placeholder="Medium Date-Time"
            appendTo="body"
          >
          </ng-select>
        </div>
        <div class="col-md-6">
          <ng-select
            appearance="fill"
            #department
            [items]="fullDtList"
            bindLabel="optionText"
            formControlName="selectedFullDt"
            (change)="onClickFullDt()"
            placeholder="Full Date-Time"
            appendTo="body"
          >
          </ng-select>
        </div>
      </div> -->
    </mat-tab>

    <mat-tab label="Notification" *ngIf="false">
      <div class="emp-notification">
        <app-employee-notification></app-employee-notification>
      </div>
    </mat-tab>
  </mat-tab-group>
  <!--   <mat-card-footer>
    <mat-dialog-actions align="end" class="mat-card-action">
      <button mat-button mat-dialog-close >    
      Cancel</button>
      <button mat-button [mat-dialog-close]="true" cdkFocusInitial mat-raised-button color="primary">Save</button>
    </mat-dialog-actions>
  </mat-card-footer> -->
</mat-dialog-content>
<mat-dialog-actions class="dg-btn">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button
    mat-button
    [mat-dialog-close]="true"
    cdkFocusInitial
    mat-raised-button
    color="primary"
    (click)="onSave()"
  >
    Save
  </button>
</mat-dialog-actions>
